var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.565 15.1091H1.38007C0.882169 15.1091 0.435834 14.8519 0.186154 14.4212C-0.0584174 13.9992 -0.0621561 13.5014 0.175872 13.0554L6.76839 0.706234C7.00445 0.264012 7.45462 0 7.97252 0C8.49045 0 8.94059 0.264012 9.17668 0.706234L15.7692 13.0554C16.0073 13.5014 16.0035 13.9992 15.7589 14.4212C15.5092 14.8519 15.0629 15.1091 14.565 15.1091Z",
    fill: "#FED71F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7693 13.0554L9.17682 0.706234C8.94072 0.264012 8.49059 0 7.97266 0V15.1091H14.5651C15.0631 15.1091 15.5094 14.8519 15.759 14.4212C16.0036 13.9992 16.0074 13.5014 15.7693 13.0554Z",
    fill: "#F1C700"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97474 13.0842C7.28757 13.0842 6.72852 12.5252 6.72852 11.838C6.72852 11.1509 7.28757 10.5918 7.97474 10.5918C8.66191 10.5918 9.22096 11.1509 9.22096 11.838C9.22096 12.5252 8.66191 13.0842 7.97474 13.0842Z",
    fill: "#313131"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97477 9.3456C7.28757 9.3456 6.72852 8.78655 6.72852 8.09938V5.40443C6.72852 4.71726 7.28757 4.1582 7.97474 4.1582C8.66191 4.1582 9.22096 4.71726 9.22096 5.40443V8.09938C9.22096 8.78655 8.66194 9.3456 7.97477 9.3456Z",
    fill: "#313131"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97269 4.15918H7.97266V9.34658H7.97272C8.65989 9.34658 9.21891 8.78753 9.21891 8.10036V5.4054C9.21891 4.71827 8.65985 4.15918 7.97269 4.15918Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97269 10.5928H7.97266V13.0852H7.97269C8.65985 13.0852 9.21891 12.5262 9.21891 11.839C9.21891 11.1518 8.65985 10.5928 7.97269 10.5928Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.d01d7422aed6341b32c539db58c02b69.svg";
export { ForwardRef as ReactComponent };